import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import usersRequest from "../../request/usersRequest";
import BannerMessageFixed from "../common/bannerMessageFixed/bannerMessageFixed";
import PasswordField from "../common/passwordField/passwordField";
import "./forgotPasswordConfirm.css";

const ConfirmForgotPassword = () => {
	const { language } = useContext(CombinedContext);
	const navigate = useNavigate();

	const [email, setEmail] = useState("");
	const [code, setCode] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [banner, setBanner] = useState({ text: "", type: "info", exiting: false });

	function isStrongPassword(p) {
		return (
			typeof p === "string" &&
			p.length >= 8 &&
			/[A-Z]/.test(p) &&
			/[a-z]/.test(p) &&
			/[0-9]/.test(p) &&
			/[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`+=-]/.test(p)
		);
	}

	const showBanner = (text, type = "error") => {
		setBanner({ text, type, exiting: false });
		setTimeout(() => setBanner((prev) => ({ ...prev, exiting: true })), 2500);
		setTimeout(() => setBanner({ text: "", type: "info", exiting: false }), 2750);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!email || !code || !password || !confirmPassword) {
			showBanner(translations[language].confirmForgotPassword.toast.required);
			return;
		}

		if (!isStrongPassword(password)) {
			showBanner(translations[language].confirmForgotPassword.toast.weakPassword);
			return;
		}

		if (password !== confirmPassword) {
			showBanner(translations[language].confirmForgotPassword.toast.mismatch);
			return;
		}

		try {
			setLoading(true);
			await usersRequest.confirmForgotPassword({ email, code, newPassword: password });
			setSuccess(true);
			setTimeout(() => navigate("/signin"), 1500);
		} catch (err) {
			console.error(err);
			showBanner(translations[language].confirmForgotPassword.toast.invalidCode);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="container">
			<div className="card" style={{ maxWidth: 400, margin: "40px auto" }}>
				<div className="hd">
					<div>{translations[language].confirmForgotPassword.title}</div>
				</div>
				<div className="bd">
					{success ? (
						<p className="sf-confirmfp-success">
							{translations[language].confirmForgotPassword.success}
						</p>
					) : (
						<>
							<p className="sf-confirmfp-subtitle">
								{translations[language].confirmForgotPassword.subtitle}
							</p>
							<div className="row">
								<input
									type="email"
									className="input"
									placeholder={translations[language].confirmForgotPassword.email}
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
								<input
									type="text"
									className="input"
									placeholder={translations[language].confirmForgotPassword.code}
									value={code}
									onChange={(e) => setCode(e.target.value)}
								/>
								<PasswordField
									value={password}
									onChange={setPassword}
									placeholder={translations[language].confirmForgotPassword.password}
									autoComplete="new-password"
								/>
								<PasswordField
									value={confirmPassword}
									onChange={setConfirmPassword}
									placeholder={translations[language].confirmForgotPassword.confirmPassword}
									autoComplete="new-password"
								/>
							</div>
							<button
								className="btn brand"
								style={{ width: "100%", marginTop: 10 }}
								onClick={handleSubmit}
								disabled={loading}
							>
								{loading
									? translations[language].confirmForgotPassword.submitting
									: translations[language].confirmForgotPassword.submit}
							</button>
						</>
					)}

					<BannerMessageFixed
						text={banner.text}
						type={banner.type}
						exiting={banner.exiting}
					/>
				</div>
			</div>
		</div>
	);
};

export default ConfirmForgotPassword;